import styled from 'styled-components';

export const ToggleText = styled.div`
  margin-right: 10px;
  font-size: 15px;
  font-style: normal;
`;
